module.exports = __webpack_public_path__ + "static/media/IconModoC.837b7943.svg";